import { Pagination, PaginationContent, PaginationItem, PaginationLink } from "@/components/ui/pagination";

function getPageHref(page: number): string {
  return page === 1 ? "/resources" : `/resources/page/${page}`;
}

interface ResourcesPaginatorProps {
  totalPages: number;
  currentPage: number;
}

export default function ResourcesPaginator({ totalPages, currentPage }: ResourcesPaginatorProps) {
  return (
    <Pagination>
      <PaginationContent>
        {Array.from({ length: totalPages }, (_, index) => {
          const page = index + 1;
          return (
            <PaginationItem key={page}>
              <PaginationLink href={getPageHref(page)} isActive={page === currentPage}>
                {page}
              </PaginationLink>
            </PaginationItem>
          );
        })}
      </PaginationContent>
    </Pagination>
  );
}
